export const OrderDetailsConstants = {
    MAX_NOTES_LENGTH: 10000,
    SUCCESS_ALERT_MESSAGE: 'Order has been successfully saved.',
    ORDER_TOTAL_GRID_LABEL: 'Order Total',
    BALANCE_DUE_GRID_LABEL: 'Balance Due',
} as const;
